import { render } from "./ResultTableItemMessages.vue?vue&type=template&id=2bd42e99&scoped=true"
import script from "./ResultTableItemMessages.vue?vue&type=script&lang=js"
export * from "./ResultTableItemMessages.vue?vue&type=script&lang=js"

import "./ResultTableItemMessages.vue?vue&type=style&index=0&id=2bd42e99&scoped=true&lang=css"

import exportComponent from "C:\\AgentIFAS\\_work\\45\\s\\Nezivotko.Web2\\CreditWorthiness\\real-world-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bd42e99"]])

export default __exports__